import { render, staticRenderFns } from "./portfolio-chart-grid.component.vue?vue&type=template&id=6b6b2191&scoped=true"
import script from "./portfolio-chart-grid.component.vue?vue&type=script&lang=js"
export * from "./portfolio-chart-grid.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b2191",
  null
  
)

export default component.exports